import Vue from 'vue'
import show from '~/pug/blocks/plainform/show.js'
import plainform from '~/pug/blocks/plainform/plainform.vue'


if (document.querySelectorAll('.donwload-center__getfiles-js').length) {
  const modal = new Vue({
    el: '.donwload-center__getfiles-js',
    components: {
      plainform
    }
  });

  show(17)
}
